import React, { useState, useEffect } from "react";
import styles from "./SlidesContainer.module.css";
import {
	bgColor,
	fw500,
	titleXXL,
	tertiaryTextColor,
} from "../../../Global.module.css";
import SlidesCard from "../SlidesCard/SlidesCard";
import EmptyBox from "../../../assets/box.svg";
import { getSlidesList } from "../../../helpers/api";
import Modal from "../../reusable/Modal/Modal";
import ShareMenu from "../../reusable/ShareMenu/ShareMenu";
import DeleteMenu from "../../reusable/DeleteMenu/DeleteMenu";
import CudyLoader from "../../reusable/Loader/CudyLoader";

export default function SlidesContainer() {
	const [state, setState] = useState({
		showModal: false,
		menuData: null,
		showShareMenu: false,
		showDeleteMenu: false,
	});
	const [slides, setSlides] = useState([]);

	const [loading, setLoading] = useState(true);

	useEffect(() => {
		initSlides();
	}, []);

	const initSlides = async () => {
		let data;
		try {
			data = await getSlidesList();
		} catch (error) {
			data = [];
		}
		if (data) {
			setSlides(data);
		}
		setLoading(false);
	};

	const openShareMenu = (index) => {
		let obj = { ...state };
		obj.menuData = slides[index];
		obj.showModal = true;
		obj.showShareMenu = true;
		obj.showDeleteMenu = false;
		setState(obj);
	};

	const openDeleteMenu = (index) => {
		let obj = { ...state };
		obj.menuData = slides[index];
		obj.showModal = true;
		obj.showShareMenu = false;
		obj.showDeleteMenu = true;
		setState(obj);
	};

	const closeShareMenu = () => {
		let obj = { ...state };
		obj.menuData = null;
		obj.showModal = false;
		obj.showShareMenu = false;
		obj.showDeleteMenu = false;
		setState(obj);
		initSlides();
	};

	const closeDeleteMenu = (deleted) => {
		let obj = { ...state };
		obj.menuData = null;
		obj.showModal = false;
		obj.showShareMenu = false;
		obj.showDeleteMenu = false;
		setState(obj);
		if (deleted) return initSlides();
	};

	const menuToShow = () => {
		if (state.showShareMenu) {
			return (
				<ShareMenu
					data={state.menuData}
					closeShareMenu={closeShareMenu}
				/>
			);
		} else if (state.showDeleteMenu) {
			return (
				<DeleteMenu
					id={state.menuData.id}
					closeDeleteMenu={closeDeleteMenu}
				/>
			);
		} else return null;
	};

	const slidesCardList = () => {
		let arr = [];
		for (let i = 0; i < slides.length; i++) {
			arr.push(
				<SlidesCard
					key={i}
					index={i}
					data={slides[i]}
					openShareMenu={openShareMenu}
					openDeleteMenu={openDeleteMenu}
					initSlides={initSlides}
				/>
			);
		}
		return arr;
	};

	if (loading) {
		return (
			<div className={styles.loader}>
				<CudyLoader />
			</div>
		);
	}

	return (
		<div className={`${styles.container} ${bgColor}`}>
			{state.showModal ? <Modal>{menuToShow()}</Modal> : null}
			{!slides.length ? (
				<div className={styles.empty}>
					<img
						src={EmptyBox}
						alt="Empty"
						width="72px"
						height="72px"
					/>
					<br />
					<p className={`${titleXXL} ${tertiaryTextColor} ${fw500}`}>
						It seems like you haven't created any slides yet.
					</p>
				</div>
			) : (
				<div className={`${styles.slidesContainer}`}>
					{slidesCardList()}
				</div>
			)}
		</div>
	);
}
